module.exports = __webpack_public_path__ + "static/media/blank-logo.8543a9fa.svg";